import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import ContactForm from './common/ContactForm';

const { FiMail, FiPhone, FiMapPin } = FiIcons;

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-rose-600 to-purple-600 bg-clip-text text-transparent">
              Let's Connect
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ready to embark on your mindful creative journey?
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16">
          <div className="space-y-8">
            <div className="space-y-6">
              {[
                { icon: FiPhone, title: "Call Us", details: "(312) 868-2598" },
                { icon: FiMail, title: "Email Us", details: "admin@ijourney.us" },
                { icon: FiMapPin, title: "Studio", details: "550 Frontage Rd, Northfield, IL" }
              ].map((contact, index) => (
                <div key={index} className="flex items-start space-x-4 p-4 rounded-2xl hover:bg-rose-50 transition-all">
                  <div className="flex-shrink-0 w-12 h-12 bg-rose-100 rounded-xl flex items-center justify-center">
                    <SafeIcon icon={contact.icon} className="h-6 w-6 text-rose-600" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800">{contact.title}</h4>
                    <p className="text-gray-700">{contact.details}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gray-50 p-8 md:p-10 rounded-[2.5rem] border border-gray-100 shadow-sm relative">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;